import * as React from 'react'
import { ReactElement } from 'react'
import { Stack, StackItem } from '@fluentui/react'
import Loading from '../../components/Loading'
import { useRouteMatch } from 'react-router-dom'
import useFileData, { FileData } from '../../hooks/file/useFileData'
import useFilePages, { FilePageProps } from '../../hooks/file/useFilePages'
import ViewFileHeader from '../../components/File/ViewFileHeader'
import ViewFileHeaderV2 from '../../v2/pages/File/ViewFileHeader'
import ViewFilePivotItems from '../../components/File/ViewFilePivotItems'
import { makeStyles, MessageBar, tokens } from '@fluentui/react-components'

// @ts-expect-error("dompurify exports differ from what ts-lint is expecting and cannot see the default export")
import DOMPurify from 'dompurify'
import useLocalStorage from '../../hooks/useLocalStorage'

const useStyles = makeStyles({
    alert: {
        marginLeft: tokens.spacingHorizontalS,
        marginRight: tokens.spacingHorizontalS,
    },
})

export type ViewFileProps = {
    file: FileData
    fileId: string
    activePage: FilePageProps
}

export default function ViewFile(): ReactElement {
    const routeMatch = useRouteMatch<{ fileId: string }>()
    const fileId = routeMatch.params?.fileId
    const { activePage } = useFilePages(fileId)
    const { file, getActivePageAction } = useFileData(fileId, activePage)
    const styles = useStyles()

    const { loaded: loadedNewVersion, values: newVersion } = useLocalStorage<boolean, boolean>({
        key: 'newVersion',
        defaultValues: false,
        fromJson: values => values,
        toJson: values => values,
    })

    if (!file.current.loaded || !activePage) {
        return <Loading />
    }

    return (
        <Stack tokens={{ childrenGap: 's1' }}>
            {loadedNewVersion && newVersion ? (
                <ViewFileHeaderV2 file={file} fileId={fileId} activePage={activePage} />
            ) : (
                <ViewFileHeader file={file} fileId={fileId} activePage={activePage} />
            )}
            {file.current.data.notification && (
                <MessageBar intent="warning" className={styles.alert} layout={'multiline'}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(file.current.data.notification)?.replaceAll('\n', '<br/>'),
                        }}
                    ></div>
                </MessageBar>
            )}
            <ViewFilePivotItems file={file} fileId={fileId} activePage={activePage} />
            <StackItem>{activePage?.content(file, getActivePageAction())}</StackItem>
        </Stack>
    )
}
